export const RoutesString = {
  PageNotFound: '/404',

  // -------------> Home ---
  Home: `/`,

  // -------------> Home ---
  Contacts: `/contacts`,

  // -------------> Works ---
  Works: '/works',

  // -------------> Teams ---
  Teams: '/teams',
};
